export const PRIMARY = "#337ab7"; //blue
export const SECONDARY = "#dddddd"; //grey
export const SUCCESS = "#337ab7"; //green
export const WARNING = "#337ab7"; //yellow
export const DANGER = "red"; //red